import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import FiltroFacturacionMaquinaria from "./FiltroFacturacionMaquinaria";
import { useBox } from "./useBox";
import { GetKey } from "./GetContainer";
import VisibilityIcon from '@mui/icons-material/Visibility';
import DetalleFacturacionModal from "./DetalleFacturacionModal";
import EditarModeloModal from "./EditarModeloModal";
import EditNoteIcon from "@mui/icons-material/EditNote";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export const FacturacionMaquinariaScreen = () => {
    const history = useHistory();
    const { state } = useLocation();
    const [facturaciones, setFacturacion] = useState([])
    const [boxstate, setBoxState] = useBox();
    const [openModalFacturacion, setOpenModalFacturacion] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [selectedNip, setSelectedNip] = useState('');
    const [selectedID, setSelectedID] = useState('');
    const [selectedNipEdit, setSelectedNipEdit] = useState('');
    const [selectedNEconomico, setSelectedNEconomico] = useState('');

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const keyCounts = {};

    const getKey = (fac) => {
        const keyBase = `${fac.nip}-${fac.fecha_venta}-${fac.primera_venta}-${fac.cancelado}`;

        if (keyCounts[keyBase]) {
            keyCounts[keyBase] += 1;
        } else {
            keyCounts[keyBase] = 1;
        }

        return `${keyBase}-${keyCounts[keyBase]}`;
    };

    const handleOpenModalFacturacion = (nip) => {
        setSelectedNip(nip);
        setOpenModalFacturacion(true);
    };

    const handleCloseModalFacturacion = () => {
        setLoader({ ...loader, mostrar: true });
        onExecute(boxstate.ejercicio, boxstate.periodo, boxstate.linea, boxstate.advertencia || 'C');
        setLoader({ ...loader, mostrar: false });
        setOpenModalFacturacion(false);
        setSelectedNip(null);
    };

    const handleOpenModalEditar = (id, nip, neco) => {
        setSelectedID(id);
        setSelectedNipEdit(nip)
        setSelectedNEconomico(neco)
        setOpenModalEditar(true);
    };

    const handleCloseModalEditar = () => {
        setLoader({ ...loader, mostrar: true });
        onExecute(boxstate.ejercicio, boxstate.periodo, boxstate.linea, boxstate.advertencia || 'C');
        setLoader({ ...loader, mostrar: false });
        setOpenModalEditar(false);
        setSelectedID(null);
    };


    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        onExecute(boxstate.ejercicio, boxstate.periodo, boxstate.linea, boxstate.advertencia || 'C');
        setLoader({ ...loader, mostrar: false });
    }, []);

    const onExecute = (ejercicio, periodo, linea, advertencia) => {
        var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
        var adr = GetKey(boxstate.pv.adr, ["idadr"]);
        if (sucursales === undefined || sucursales === null || sucursales === "") {
            sucursales = "0";
        }
        if (adr === undefined || adr === null || adr === "") {
            adr = "0";
        }
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(
                    `ListadoFacturacionMaquinaria/Parametros?ejercicio=${ejercicio}&periodo=${periodo}&linea=${linea}&advertencia=${advertencia}&sucursal=${sucursales}&adr=${adr}`
                )
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setFacturacion(result)
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    reject(error);
                    return;
                });
        });
    };

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    // console.log(facturaciones)
    return (
        <PlantillaScreen
            titulo={`FACTURACIÓN DE MAQUINARIA`}
            className={"facturacion-maquinaria-main-screen"}
            className_main={1}
        >
            <div className="facturacion-maquinaria-actions">
                <div
                    className="facturacion-maquinaria-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="facturacion-maquinaria-actions-filtro">
                    <FiltroFacturacionMaquinaria
                        onExecute={onExecute}
                        boxState={boxstate}
                        onBoxChange={setBoxState}
                    />
                </div>
                <div className="contador-facturas">Registros Encontrados: {facturaciones.length}</div>
            </div>
            <DetalleFacturacionModal
                open={openModalFacturacion}
                onClose={handleCloseModalFacturacion}
                nip={selectedNip}
            />
            <EditarModeloModal
                open={openModalEditar}
                onClose={handleCloseModalEditar}
                id={selectedID}
                nip={selectedNipEdit}
                neconomico={selectedNEconomico}
            />
            <div className="facturacion-maquinaria-cliente-screen">
                <LoaderScreen loader={loader} />
                <div className="facturacion-maquinaria-cliente-container scroll-4">
                    <table>
                        <thead>
                            <tr>
                                <th>Línea</th>
                                <th>
                                    <div>Sucursal</div>
                                </th>
                                {/* <th>
                                    <div>ID Cliente</div>
                                </th> */}
                                <th>
                                    <div>Cliente</div>
                                </th>
                                <th>
                                    <div>Vendedor</div>
                                </th>
                                <th>
                                    <div>Primera Venta</div>
                                </th>
                                <th>
                                    <div>Fecha</div>
                                </th>
                                {/* <th>
                                    <div>Serie</div>
                                </th> */}
                                <th className="column-economico">
                                    <div>No. Económico</div>
                                </th>
                                <th>
                                    <div>Modelo</div>
                                </th>
                                <th>
                                    <div>Importe</div>
                                </th>
                                <th>
                                    <div style={{ color: 'transparent' }}>.</div>
                                </th>
                                {/* <th>
                                    <div>Costo</div>
                                </th>
                                <th>
                                    <div>Utilidad</div>
                                </th>
                                <th>
                                    <div>NIP</div> 
                                </th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {facturaciones.map((fac) => (
                                <tr className={fac.eliminado === 1 ? "fila-eliminada" : ""}
                                    style={{
                                        borderLeft: fac.cancelado === 1 ? "3px solid red" : "3px solid green",
                                        color: fac.eliminado === 1 ? "white" : (fac.cancelado === 1 ? "red" : "black"),
                                    }} key={getKey(fac)}>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada alerta" : "ta-left alerta"}>{fac.alerta === 'S' ? <ErrorOutlineIcon className="alerta-error"/> : <CheckCircleOutlineIcon className="alerta-check"/>} {capitalizeWords(fac.scorecard)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.sucursal)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.razonsocial)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.vendedor)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-center celda-eliminada" : "ta-center"}>{fac.primera_venta}</td>
                                    <td className={fac.eliminado === 1 ? "ta-center celda-eliminada" : "ta-center"}>{fac.fecha_venta}</td>
                                    <td className={fac.eliminado === 1 ? "ta-center column-economico celda-eliminada" : "ta-center column-economico"}>{fac.neconomico}</td>
                                    <td className={fac.eliminado === 1 ? "ta-left celda-eliminada" : "ta-left"}>{capitalizeWords(fac.modelo)}</td>
                                    <td className={fac.eliminado === 1 ? "ta-right celda-eliminada" : "ta-right"}>{FormatMoney(fac.importe_venta, 0)}</td>
                                    <td className={fac.eliminado === 1 ? "celda-eliminada" : ""}>
                                        {fac.nip !== null && fac.nip !== "S/S" ? (
                                            <div className="listado-clientes-gestionar-detalle-button">
                                                {fac.nip !== null && fac.nip !== "S/S" && (
                                                    <div className="listado-clientes-gestionar-detalle-button" style={{ display: 'flex', flexDirection: 'column' }}>
                                                        <div
                                                            className="detalle"
                                                            onClick={() => handleOpenModalFacturacion(fac.nip)}
                                                            style={{ marginBottom: "5px" }} // Espacio entre los botones
                                                        >
                                                            <VisibilityIcon /> Detalle
                                                        </div>
                                                        {fac.modelo === null || fac.modelo === "" ? (
                                                            <div
                                                                className="editar"
                                                                onClick={() => handleOpenModalEditar(fac.id, fac.nip, fac.neconomico)} // Define la acción que deseas ejecutar
                                                            >
                                                                <EditNoteIcon /> Editar
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                )}
                                            </div>
                                        ) : null}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </PlantillaScreen>
    );
};
